import { BaseModel } from './base';
import { User } from './User';

export class StudentList extends BaseModel {
	constructor(public id: number, public title: string, public users: User[], public user_ids: number[], public owner_id: number) {
		super();
	}

	static fromJSON(JSON: any): StudentList | null {
		if (!JSON) {
			return null;
		}

		const id: number = JSON['id'],
			title: string = JSON['title'],
			users: User[] = JSON['users'] ? JSON['users'] : [], // v1 student list routes include full user objects
			user_ids: number[] = JSON['user_ids'] ? JSON['user_ids'] : [], // v2 student list routes include only user IDs
			owner_id: number = JSON['owner_id'];

		return new StudentList(id, title, users, user_ids, owner_id);
	}
}
